"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartNotificationPopup = void 0;
const modal_1 = require("../modal");
const utils_1 = require("../../utils/utils");
const dom_1 = require("../../utils/dom");
const check_media_1 = require("../../utils/check-media");
const HEADER_SELECTOR = 'header-component';
const HEADER_WITH_POPUP_CLASS = 'shopify-section-header--with-cart-popup';
class CartNotificationPopup extends modal_1.ModalComponent {
    wasHeaderHidden;
    purchaseHandler(html, parsedState) {
        const header = (0, utils_1.$el)(HEADER_SELECTOR);
        this.wasHeaderHidden = header.isHidden;
        if (this.element) {
            const newNode = (0, utils_1.$el)(`#CartNotificationPopupItem-${parsedState.id}`, html);
            const node = (0, utils_1.$el)('[data-cart-notification-popup]', this.element);
            (0, dom_1.replaceNodeChildren)(node, newNode);
            this.toggleMobileHeader(false).then(() => {
                this.show();
            });
        }
    }
    async hide() {
        await super.hide();
        if (this.wasHeaderHidden) {
            this.toggleMobileHeader(true);
        }
    }
    toggleMobileHeader = async (isToShow) => {
        if ((0, check_media_1.isMobile)()) {
            const header = (0, utils_1.$el)(HEADER_SELECTOR);
            header.setHidden(isToShow);
            header.parentElement.classList.toggle(HEADER_WITH_POPUP_CLASS, !isToShow);
            await (0, utils_1.delay)(300);
        }
    };
}
exports.CartNotificationPopup = CartNotificationPopup;
